import type { FC } from 'react';
import PrimaryLabel from '../../../../components/Labels/PrimaryLabel';
import Paper from '../../../../components/Paper/Paper';
import ClaimsSettingsCarrierForm from './CarrierForm/ClaimsSettingsCarrierForm';

const ClaimsSettingsCarrierInformationForm: FC = () => {
  return (
    <Paper className="d-flex flex-direction-column flex-nowrap" border>
      <div className="px-15 py-10 border-bottom-border">
        <PrimaryLabel>Carrier Information</PrimaryLabel>
      </div>
      <div className="px-15 pt-10">
        <ClaimsSettingsCarrierForm />
      </div>
    </Paper>
  );
};

export default ClaimsSettingsCarrierInformationForm;
